import Carousel from "react-bootstrap/Carousel";
import CardMedia from "@mui/material/CardMedia";

function CarouselFadeExample() {
  return (
    <Carousel fade>
      {/* 1 복도 */}

      <Carousel.Item>
        <CardMedia component="img" image="/img/위례_27.jpg" alt="wiryeimg" />

        <Carousel.Caption>
          <h3>입구</h3>
          <h6>성원언어심리센터 위례점</h6>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 2 대기실 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/위례_3.jpg" alt="therapist1" />

        <Carousel.Caption>
          <h3>안내 데스크</h3>
          <h6>성원언어심리센터 위례점</h6>
        </Carousel.Caption>
      </Carousel.Item>

      {/* 3 치료실 */}
      <Carousel.Item>
        <CardMedia component="img" image="/img/위례_5.jpg" alt="therapist1" />

        <Carousel.Caption>
          <h3>대기실</h3>
          <h6>성원언어심리센터 위례점</h6>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <CardMedia component="img" image="/img/위례_7_1.jpg" alt="therapist1" />
        <Carousel.Caption>
          <h3>복도</h3>
          <h6>성원언어심리센터 위례점</h6>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <CardMedia component="img" image="/img/위례_11.jpg" alt="therapist1" />
        <Carousel.Caption>
          <h3>놀이치료실</h3>
          <h6>성원언어심리센터 위례점</h6>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <CardMedia component="img" image="/img/위례_24.jpg" alt="therapist1" />
        <Carousel.Caption>
          <h3>놀이치료실</h3>
          <h6>성원언어심리센터 위례점</h6>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <CardMedia component="img" image="/img/위례_13.jpg" alt="therapist1" />
        <Carousel.Caption>
          <h3>인지치료실</h3>
          <h6>성원언어심리센터 위례점</h6>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <CardMedia component="img" image="/img/위례_15.jpg" alt="therapist1" />
        <Carousel.Caption>
          <h3>언어치료실</h3>
          <h6>성원언어심리센터 위례점</h6>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <CardMedia component="img" image="/img/위례_19.jpg" alt="therapist1" />
        <Carousel.Caption>
          <h3>언어치료실</h3>
          <h6>성원언어심리센터 위례점</h6>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <CardMedia component="img" image="/img/위례_21.jpg" alt="therapist1" />
        <Carousel.Caption>
          <h3>언어치료실</h3>
          <h6>성원언어심리센터 위례점</h6>
        </Carousel.Caption>
      </Carousel.Item>

      <Carousel.Item>
        <CardMedia component="img" image="/img/위례_2.jpg" alt="therapist1" />
        <Carousel.Caption>
          <h3>로고</h3>
          <h6>성원언어심리센터 위례점</h6>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default CarouselFadeExample;
